import { Star } from "lucide-react";
import { formatRating } from "@/lib/format";
import { useLanguage } from "@/i18n/LanguageContext";

export const Rating = ({ value, count }) => {
  const { lang } = useLanguage();
  return (
    <span data-testid="rating" className="flex items-center gap-1 text-sm">
      <Star className="h-4 w-4 fill-amber-400 text-amber-400" />
      <span className="font-semibold text-slate-900">{formatRating(value, lang)}</span>
      {count != null && <span className="text-slate-400">({count})</span>}
    </span>
  );
};
